import { useState, useEffect } from 'react';
import { apiFetch } from '../utils/streamApi';
import { PlayDevicesSection, PauseDevicesSection } from '../components/DevicesPanel';
import { DEVICES_PAUSE_CHANGED, fmtRemaining } from '../utils/devicesPause';
import '../css/parvekshak.css';

// Desktop "Play & Pause Devices": the mobile Dashboard's two tiles, side by side.
// Named after those tiles so someone who knows the phone finds it at once. One
// page, not two menus: a test still sounds while paused (the pause only stops
// alerts from firing devices), so whoever tests must see that alerts won't.

const card = { background: 'var(--surface)', border: '1px solid var(--border)', borderRadius: 12, padding: 18 };
const h2   = { fontSize: 15, fontWeight: 700, margin: '0 0 10px' };

export default function DevicesPage() {
  const [pause, setPause] = useState({ paused: false, remaining_secs: 0 });

  const loadPause = () => {
    apiFetch('/controls/devices/pause-status').then(r => r.json()).then(setPause).catch(() => {});
  };
  useEffect(() => {
    loadPause();
    const t = setInterval(loadPause, 30000);   // keeps the countdown honest
    window.addEventListener(DEVICES_PAUSE_CHANGED, loadPause);
    return () => { clearInterval(t); window.removeEventListener(DEVICES_PAUSE_CHANGED, loadPause); };
  }, []);

  return (
    <div style={{ padding: '22px 26px', overflowY: 'auto', height: '100%' }}>
      <h1 style={{ fontSize: 22, fontWeight: 700, margin: '0 0 14px' }}>Play &amp; Pause Devices</h1>

      {pause.paused && (
        <div role="status" style={{ ...card, padding: '10px 14px', marginBottom: 14, borderColor: '#f0d49b', background: '#fff8eb', color: '#7a4700', fontSize: 13 }}>
          ⏸ Devices are paused — {fmtRemaining(pause.remaining_secs)}. Alerts won't sound the siren or switch relays until you resume; testing here still works.
        </div>
      )}

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))', gap: 16, alignItems: 'start' }}>
        <section style={card}>
          <h2 style={h2}>▶️ Play Devices</h2>
          <PlayDevicesSection />
        </section>
        <section style={card}>
          <h2 style={h2}>⏸ Pause Devices</h2>
          <PauseDevicesSection paused={pause.paused} remaining={pause.remaining_secs} onChanged={loadPause} />
        </section>
      </div>
    </div>
  );
}
